import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewRef } from "@angular/core";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { Employee } from "../core/model/employee/employee";
import { PageEmployee } from "../core/model/page-employee";
import { EmployeeService } from "../core/service/employee.service";
import { ImportUserComponent } from "./import-user/import-user.component";
import { ChangerAgenceUserComponent } from "./changer-agence-user/changer-agence-user.component";
import { DesactiverUserComponent } from "./desactiver-user/desactiver-user.component";

@Component({
  selector: "app-user",
  templateUrl: "./user.component.html",
  styleUrls: ["./user.component.scss"],
})
export class UserComponent implements OnInit, OnDestroy {
  page: number = 1;
  totalElements: number = 0;
  filter: String = "";

  employees: Employee[];
  pageEmployee: PageEmployee;

  private destroy$ = new Subject<void>();

  constructor(
    private _router: Router,
    private _employeeService: EmployeeService,
    private modalService: NgbModal,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.getEmployeePageable(this.filter, 0, 10);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadPage(page: number): void {
    page = page - 1;
    this.getEmployeePageable(this.filter, page, 10);
  }

  searchAndRefresh(): void {
    this.getEmployeePageable(this.filter, 0, 10);
  }

  getEmployeePageable(filter, page, size) {
    this._employeeService
      .getEmployeePageable(filter, page, size)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (data) => {
          this.employees = data.content;
          this.totalElements = data.totalElements;
          this.safeDetectChanges();
        },
        (error) => {
          console.log(error);
          this.employees = [];
          this.totalElements = 0;
          this.safeDetectChanges();
        }
      );
  }

  private safeDetectChanges(): void {
    const view = this.cdr as ViewRef;
    if (view && !view.destroyed) {
      this.cdr.detectChanges();
    }
  }

  add(): void {
    this._router.navigate(["/parametrage/user/add-user"]);
  }

  edit(id): void {
    this._router.navigate(["/parametrage/user/edit-user/" + id]);
  }

  import() {
    const modalRef = this.modalService.open(ImportUserComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });

    modalRef.result.then(
      (data) => {
        this.getEmployeePageable(this.filter, 0, 10);
      },
      (reason) => {}
    );
  }

  changerAgence(employeeId): void {
    const modalRef = this.modalService.open(ChangerAgenceUserComponent, {
      centered: true,
    });
    modalRef.componentInstance.employeeId = employeeId;

    modalRef.result.then(
      (data) => {
        this.searchAndRefresh();
      },
      (reason) => {}
    );
  }

  desactiver(employeeId): void {
    const modalRef = this.modalService.open(DesactiverUserComponent, {
      centered: true,
    });
    modalRef.componentInstance.employeeId = employeeId;

    modalRef.result.then(
      (data) => {
        this.searchAndRefresh();
      },
      (reason) => {}
    );
  }
}
